import { useState } from "react";
import { getCourseInfo } from "../../../CourseRegistration/admissionDates.js";
import NextBatchRegCard from "./../../../CourseRegistration/NextBatchRegCard";
import calculateRemainingDays from "./../../../utils/calculateRemainingDays";
import RefundPolicy from "./../../Aqeedah/RefundPolicy";
import ArabicGroupCard from "./../ArabicResultPage/ArabicGroupCard";
import ArabicPayment from "./ArabicPayment";
import ArabicRegistrationForm from "./ArabicRegistrationForm";

const ArabicRegistration = () => {
  const [info, setInfo] = useState({
    gender: "",
    level: "",
    payment: "",
  });

  const courseInfo = getCourseInfo("arabic");
  const today = new Date();
  const flexible = new Date(courseInfo.flexibleAdmissionDate);

  // if level 1, then show link fo upcoming batch, if level 2, then show link for running batch, if level 3, then show link for previous batch.
  let updatedBatch = courseInfo.upcomingBatch;
  if (info.level === 3) {
    updatedBatch = courseInfo.upcomingBatch - 2;
  } else if (info.level === 2) {
    updatedBatch = courseInfo.upcomingBatch - 1;
  }
  let updatedLevel = info.level === 2 ? 3 : info.level;

  return (
    <section>
      <div className="container mx-auto my-10 px-5">
        {today > flexible ||
        calculateRemainingDays(courseInfo.admissionStartDate).months > 1 ? (
          <div>
            <p className="text-xl text-blue-600 mt-10 mb-5 text-center">
              ভর্তির সময় শেষ
            </p>
          </div>
        ) : (
          <div>
            <p className="text-xl text-blue-600 mt-10 mb-5 text-center">
              আরবি ভাষা কোর্সে ভর্তির নিয়ম
            </p>

            <div className="mx-auto my-5 text-center ">
              <ul className="steps steps-vertical">
                <li className="step step-primary">
                  <a href="#send-money">সেন্ডমানি করুন</a>
                </li>
                <li className="step step-primary">
                  <a href="#reg-form">ভর্তি ফর্ম পূরণ করুন</a>
                </li>
                <li className="step step-primary">
                  <a href="#group-link">টেলিগ্রাম গ্রুপে জয়েন করুন</a>
                </li>
              </ul>
            </div>
            <ArabicRegistrationForm setInfo={setInfo} />

            <section className="mt-10">
              <div>
                <p className="text-xl text-blue-600 mt-24">গ্রুপে জয়েন করুন</p>
                <p>
                  আপনার পেমেন্ট চেক করে গ্রুপে অ্যাড করা হবে। পেমেন্ট চেক করতে
                  সময় লাগতে পারে।
                </p>
                <p className="mb-5">
                  আপনার কাছে টাকা পাঠানোর (সেন্ডমানি) ছবি বা স্ক্রিনশট থাকলে
                  ইনবক্সে দিবেন। তাহলে দ্রুত গ্রুপে অ্যাড করা সম্ভব হবে।
                </p>

                <div className="w-80 mx-auto lg:mx-0"></div>

                {info.gender && info.level ? (
                  ["paid", "due", "reverted"].includes(info.payment) ? (
                    <div className="w-80 mx-auto lg:mx-0">
                      <ArabicGroupCard
                        batch={updatedBatch}
                        gender={info.gender}
                        level={updatedLevel}
                      />
                    </div>
                  ) : info.payment === "scholarship" ? (
                    <p>
                      আমাদের কোন উস্তাদ / উস্তাদা আপনার সাথে যোগাযোগ করবেন,
                      ইনশাআল্লাহ।
                    </p>
                  ) : (
                    <p></p>
                  )
                ) : (
                  <p></p>
                )}
              </div>
            </section>

            <section>
              <p className="text-xl text-blue-600 mt-24">সেন্ডমানি করুন</p>
              <ArabicPayment />
            </section>
            <div className="my-48 ">
              <RefundPolicy />
            </div>
          </div>
        )}
        <NextBatchRegCard course="arabic" />
      </div>
    </section>
  );
};

export default ArabicRegistration;
